import { EntityType } from '@components'

import { CustomerType } from '@features/contacts/enums/customerType'

import { ZervantContactType } from '../../enums/zervantContactType'
import type { InvoiceCustomer } from '../../types/invoices/invoiceCustomer'
import type { PredefinedCustomerValues } from '../../types/predefinedCustomerValues'

export const getPredefinedCustomerValuesFromInvoiceCustomer = (
  customer: InvoiceCustomer | undefined,
): PredefinedCustomerValues => {
  if (!customer) {
    return { customerType: CustomerType.Company }
  }

  const {
    address,
    companyName,
    customerType,
    eInvoiceAddress,
    externalContactId,
    firstName,
    isPublicEntity,
    isSalesTaxExempt,
    lastName,
    vatNumber,
  } = customer
  const isCompany = customerType === ZervantContactType.Company

  return {
    address: {
      city: address?.city ?? undefined,
      country: address?.country ?? undefined,
      pobox: address?.pobox ?? undefined,
      streetAddress1: address?.streetAddress1 ?? undefined,
      streetAddress2: address?.streetAddress2 ?? undefined,
    },
    customerType: isCompany ? CustomerType.Company : CustomerType.Individual,
    eInvoiceAddress: {
      address: eInvoiceAddress?.address,
      scheme: eInvoiceAddress?.scheme || undefined,
    },
    entityType: isPublicEntity ? EntityType.Public : EntityType.Private,
    id: externalContactId ?? undefined,
    isVatExempted: isSalesTaxExempt,
    vatNumber: vatNumber ?? undefined,
    ...(isCompany
      ? { companyName: companyName ?? undefined }
      : { firstName: firstName ?? undefined, lastName: lastName ?? undefined }),
  }
}
